import { FC, SVGProps } from 'react';
import { SvgIcon } from '../SvgIcon';

export const TableSettingsIcon: FC<SVGProps<SVGSVGElement>> = props => {
	return (
		<SvgIcon height={24} width={24} {...props}>
			<g fill='currentColor' fillRule='evenodd'>
				<polygon points='17 8 13 8 13 10 17 10' />
				<polygon points='3 10 10 10 10 8 3 8' />
				<polygon points='8 11 3 11 3 13 8 13' />
				<path d='M18,2 L17.999,5 L2,5 L2,2 L18,2 Z M2,7 L17.999,7 L17.998,10 L20,10 L20,2 C20,0.897 19.103,0 18,0 L2,0 C0.897,0 0,0.897 0,2 L0,14 C0,15.103 0.897,16 2,16 L10,16 L10,14 L2,14 L2,7 Z' />
				<path d='M18,20 C16.894,20 16,19.103 16,18 C16,16.895 16.894,16 18,16 C19.104,16 20,16.895 20,18 C20,19.103 19.104,20 18,20 L18,20 Z M24.002,19 L24.002,17 L22.9,17 C22.77,16.363 22.516,15.771 22.167,15.246 L22.951,14.463 L21.538,13.048 L20.753,13.833 C20.229,13.486 19.638,13.231 19.001,13.101 L19.001,12 L17.001,12 L17.001,13.101 C16.364,13.231 15.773,13.486 15.248,13.833 L14.464,13.05 L13.051,14.465 L13.834,15.247 C13.486,15.772 13.232,16.363 13.102,17 L12,17 L12,19 L13.102,19 C13.232,19.638 13.486,20.229 13.834,20.754 L13.051,21.539 L14.466,22.952 L15.249,22.168 C15.773,22.515 16.365,22.769 17.002,22.899 L17.002,24 L19.002,24 L19.002,22.899 C19.639,22.769 20.231,22.514 20.755,22.167 L21.539,22.95 L22.952,21.535 L22.169,20.752 C22.516,20.228 22.77,19.637 22.9,19 L24.002,19 Z' />
			</g>
		</SvgIcon>
	);
};
